export default __webpack_public_path__ + "static/media/ic_bone_40.d188290d.svg";